export default __webpack_public_path__ + "static/media/cashflow-checkout-icon.94e0f54a.svg";